import { render, staticRenderFns } from "./EmbedContent.vue?vue&type=template&id=8d38a26c&"
import script from "./EmbedContent.vue?vue&type=script&lang=js&"
export * from "./EmbedContent.vue?vue&type=script&lang=js&"
import style0 from "./EmbedContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d38a26c')) {
      api.createRecord('8d38a26c', component.options)
    } else {
      api.reload('8d38a26c', component.options)
    }
    module.hot.accept("./EmbedContent.vue?vue&type=template&id=8d38a26c&", function () {
      api.rerender('8d38a26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/Card/EmbedContent.vue"
export default component.exports